import { Alert, Container } from '@mui/material';
import { NavLink, useParams } from "react-router-dom";
import { useEffect, useState } from 'react';

import { IEmployee, IEmployeeTilsAccess } from "../../../types/employee";

import { useUserContext } from "../../../contexts/userContext";

import { EmployeeService } from "../../../services/employeeService";

import PermissionGate from "../../../components/permissionGate";
import Navigation from "../../../components/header";
import EmployeePermissionsForm from "../../../components/forms/employeePermissionsForm";
import EmployeeDetailsForm from '../../../components/forms/employeeDetailsForm';
import EmployeeTilsAccessForm from '../../../components/forms/employeeTilsAccessForm';
import Spinner from '../../spinner';
import { Icons } from '../../icons';

const EmployeeEdit = () => {
	const userContext = useUserContext();
	let { id } = useParams();
	const [employee, setEmployee] = useState<IEmployee>();
	const [activeTab, setActiveTab] = useState("details");
	const [isLoadingEmployee, setIsLoadingEmployee] = useState(true);
	const [isInitialLoad, setIsInitialLoad] = useState(true);

	const getEmployee = async () => {
		if (id) {
			EmployeeService.getEmployee(id)
				.then((response) => {
					console.log('EmployeeService.getEmployee: SUCCESS', response);
					setEmployee(response.data as IEmployee);
				})
				.catch((error) => {
					console.log('EmployeeService.getEmployee: ERROR', error);
				})
				.finally(() => {
					setIsLoadingEmployee(false);
					setIsInitialLoad(false);
				});
		}
	}

	useEffect(() => {
		getEmployee();
	}, [id])

	return (
		<div className="hwi-employee-edit">
			<Navigation></Navigation>
			<Container maxWidth="lg" className="route-container">
				<PermissionGate permission={userContext.permissions?.canManageEmployees}>
					<Spinner dependency={isLoadingEmployee && isInitialLoad} text='Loading employee...'>
						<section className="management-page-header">
							<div className="title">
								<NavLink to="/employee">
									<Icons.GoBack fill="#9399ad" height="24px"></Icons.GoBack>
								</NavLink>
								{employee?.details?.firstName} {employee?.details?.lastName}
							</div>
							<div className="tabs">
								<div className={activeTab == "details" ? "tab active" : "tab"} onClick={() => setActiveTab("details")}>Details</div>
								<div className={activeTab == "permissions" ? "tab active" : "tab"} onClick={() => setActiveTab("permissions")}>Permissions</div>
								<div className={activeTab == "tils" ? "tab active" : "tab"} onClick={() => setActiveTab("tils")}>TILS</div>
							</div>
						</section>
						<Spinner dependency={isLoadingEmployee} text='Loading employee...'>
							{(employee && id) ?
								<>
									{(employee.details && activeTab == "details") &&
										<section>
											<EmployeeDetailsForm id={id} action="edit" details={employee.details} reloadData={getEmployee}></EmployeeDetailsForm>
										</section>
									}
									{employee.permissions && activeTab == "permissions" &&
										<section>
											<EmployeePermissionsForm id={id} permissions={employee.permissions}></EmployeePermissionsForm>
										</section>
									}
									{activeTab == "tils" &&
										<section>
											<EmployeeTilsAccessForm id={id} tilsAccess={employee.tilsAccess ? employee.tilsAccess : Array<IEmployeeTilsAccess>()}></EmployeeTilsAccessForm>
										</section>
									}
								</> :
								<Alert className="alert-error" severity="warning" >
									We were unable to load this employee.
								</Alert>
							}

						</Spinner>
					</Spinner>
					{/* <Json data={employee}></Json> */}
				</PermissionGate>
			</Container>
		</div>
	);
};

export default EmployeeEdit;